import { Divider, Grid, Group, Skeleton } from '@mantine/core';
import React from 'react';
import XSkeleton1Fields from '../../../../components/x-components/x-skeletons/x-skeleton-1-fields.component';
import XSkeleton3Fields from '../../../x-components/x-skeletons/x-skeleton-3-fields.component';
import XSkeleton2Fields from '../../../x-components/x-skeletons/x-skeleton-2-fields.component';

function SkeletonUpdateMIDs() {
  return (
    <>
      <Grid>
        <XSkeleton1Fields skeletonXS={6} />
        <XSkeleton3Fields />
        <XSkeleton3Fields />
        <XSkeleton3Fields />
        <XSkeleton3Fields />
        <XSkeleton3Fields />
        <XSkeleton2Fields />
      </Grid>
    </>
  );
}

export default SkeletonUpdateMIDs;
